var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'absolute top-2 right-2': _vm.fixed}},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.favorite}},[_c('i',{staticClass:"fa fa-heart text-lg",class:{'text-red-500': _vm.favorited, 'text-gray-500': !_vm.favorited}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }